import React from 'react';
// @ts-ignore
import styles from './TimelineGridLegend.module.scss';
import TimelineGridLegendItem from './TimelineGridLegendItem';
import { ITimelineGridLegend } from '../../Models/TimelineGrid/ITimelineGridLegend';
import Text from '../Base/Text/Text';

export default function TimelineGridLegend(props: ITimelineGridLegend) {
	const { items } = props;

	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>
				<Text tx='component.ePrescription.legend' inline />:
			</div>
			{items.map((item, index) => (
				<React.Fragment key={index}>
					<TimelineGridLegendItem {...item} />
				</React.Fragment>
			))}
		</div>
	);
}
